import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import RoleFieldNumber from '../components/RoleFieldNumber';
import RoleFieldListItem from '../components/RoleFieldListItem';
import { updateRoleProperties } from '../actions';

const RoleTokenDaysListItem = ({
  code,
  category,
  maxDays,
  isEditing,
  canEdit,
  updateTokenDays,
}) => (
  <List.Item className="aridhia-role-token-days-list-item">
    <RoleFieldListItem
      code={code}
      category={category}
      value={maxDays}
      type="token.days"
      isEditing={isEditing}
      canEdit={canEdit}
    />
    {canEdit && isEditing && (
    <RoleFieldNumber
      text={maxDays}
      type="token.days"
      minValue={0}
      maxValue={365}
      onChange={(value) => updateTokenDays(code, category, { max_token_length_days: value })}
    />
    )}
  </List.Item>
);

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);
  const isEditing = item ? item.isEditing : false;

  return (
    {
      canEdit: update && !item.system,
      isEditing,
      maxDays: item ? item.max_token_length_days : 0,
    }
  );
};

const mapDispatchToProps = {
  updateTokenDays: updateRoleProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleTokenDaysListItem);
